import gsap from 'gsap';
import Component from '../../classes/Component';

const root = '.js-home-alt';

const sunSection = '.js-sun';
const sunCircleSection = '.js-sun-circle';
const sunLine1Section = '.js-sun-line-1';
const sunLine2Section = '.js-sun-line-2';
const sunLine3Section = '.js-sun-line-3';
const sunDate1Section = '.js-sun-date-1';
const sunDate2Section = '.js-sun-date-2';
const sunDate3Section = '.js-sun-date-3';
const sunMonthSection = '.js-sun-month';

const logoRectBlueSection = '.js-logo-rect-blue';
const logoRectBlueLineSection = '.js-logo-rect-blue-line';
const logoLine1Section = '.js-logo-line-1';
const logoLine2Section = '.js-logo-line-2';
const logoRectSmallBlueSection = '.js-logo-rect-small-blue';
const logoRectSmallyellowSection = '.js-logo-rect-small-yellow';
const logoRectRed1Section = '.js-logo-rect-red-1';
const logoRectRed2Section = '.js-logo-rect-red-2';
const logoRectRedLineSection = '.js-logo-rect-red-line';

const homeLogoLeftSelector = '.js-home-alt-logo-left';
const homeLogoRightSelector = '.js-home-alt-logo-right';

const homeTitleSelector = '.js-home-alt-title';

const scrollSelector = '.js-scroll';

const contentItemRightSelector = '.js-content-item-right';
const contentItemleftSelector = '.js-content-item-left';

const contentBottomSelector = '.js-content-bottom';

export function pageAnimations() {

  const introDuration = .3;
  // const introDuration = .1;

  gsap.set('.page__wrapper', {
    opacity: 1,
  })

  function scrollAnimation() {
    gsap.set('.home__content', {
      opacity: 1,
    })

    gsap.set(homeTitleSelector, {
      opacity: 1,
    })

    gsap.set(scrollSelector, {
      opacity: 1,
    })

    const mainAnimation = gsap.timeline({
      defaults: {
        duration: 50,
        ease: "power1.inOut"
      },

      scrollTrigger: {
        trigger: root,
        pin: true,
        start: "top top",
        end: "+=2000",
        scrub: true,
      },
    })

    mainAnimation
      .to(homeLogoLeftSelector, {
        width: '20%',
        top: 10,
        transform: "translateY(0)"
      })
      .to(homeLogoRightSelector, {
        width: '20%',
        top: 10,
        transform: "translateY(0)"
      }, "<")
      .from(homeTitleSelector, {
        opacity: 0,
      })
      .from(contentItemRightSelector, {
        x: '200%',
        opacity: 0,
      })
      .from(contentItemleftSelector, {
        x: '-200%',
        opacity: 0,
      }, "<")
      .to(scrollSelector, {
        opacity: 0,
      })
      .from(contentBottomSelector, {
        opacity: 0,
      })
  }

  let mm = gsap.matchMedia();

  mm.add("(min-width: 992px)", () => {
    const introAnimation = gsap.timeline({
      defaults: {
        duration: introDuration,
        ease: "power1.inOut"
      },

      onComplete: () => {
        scrollAnimation();
      }
    });

    introAnimation
      .from(sunSection, {
        duration: introDuration,
        x: '-150%',
        y: '101%',
        ease: "back.out(1.5)"
      })
      .from(sunLine1Section, {
        duration: introDuration,
        xPercent: 40,
        yPercent: 600,
        opacity: 0,
      })
      .from(sunLine2Section, {
        duration: introDuration,
        xPercent: 200,
        yPercent: -10,
        opacity: 0,
      })
      .from(sunLine3Section, {
        duration: introDuration,
        xPercent: 40,
        yPercent: -550,
        opacity: 0,
      })
      .from(sunDate1Section, {
        duration: introDuration,
        opacity: 0,
      })
      .from(sunDate2Section, {
        duration: introDuration,
        opacity: 0,
      })
      .from(sunDate3Section, {
        duration: introDuration,
        opacity: 0,
      })
      .from(sunMonthSection, {
        duration: introDuration,
        opacity: 0,
      })
      .from(logoRectBlueSection, {
        opacity: 0,
        rotate: 10,
        transformOrigin: 'center',
        scale: .6
      })
      .from(logoRectBlueLineSection, {
        opacity: 0,
        rotate: 10,
        transformOrigin: 'center',
        scale: .6
      }, "<")
      .from(logoLine1Section, {
        opacity: 0,
        rotate: -10,
        transformOrigin: 'center',
        scale: .6
      })
      .from(logoLine2Section, {
        opacity: 0,
        rotate: 10,
        transformOrigin: 'center',
        scale: .6
      })
      .from(logoRectSmallBlueSection, {
        opacity: 0,
      }, "<")
      .from(logoRectSmallyellowSection, {
        opacity: 0,
      }, "<")
      .from(logoRectRed1Section, {
        rotate: 10,
        transformOrigin: 'center',
        opacity: 0,
        scale: .6
      })
      .from(logoRectRed2Section, {
        rotate: 10,
        transformOrigin: 'center',
        opacity: 0,
        scale: .6
      }, "<")
      .from(logoRectRedLineSection, {
        rotate: 10,
        transformOrigin: 'center',
        opacity: 0,
        scale: .6
      }, "<")


    const line1Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const line2Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const line3Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const circleAnim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });

    line1Anim
      .to(sunLine1Section, {
        // duration: .8,
        y: -5,
        x: -5,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 0,
        x: -5,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 5,
        x: 0,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 5,
        x: 5,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 0,
        x: 0,
      });

    line2Anim
      .to(sunLine2Section, {
        // duration: .8,
        y: 5,
        x: 5,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: 0,
        x: 0,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: -5,
        x: 0,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: -5,
        x: 5,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: 0,
        x: 0,
      })

    line3Anim
      .to(sunLine3Section, {
        // duration: .8,
        y: 0,
        x: 5,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: -5,
        x: 0,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: 0,
        x: -5,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: 5,
        x: 0,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: 0,
        x: 0,
      })

    circleAnim
      .to(sunCircleSection, {
        // duration: .8,
        y: 3,
        x: 0,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: -3,
        x: 0,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: 0,
        x: -3,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: 3,
        x: 0,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: 0,
        x: 0,
      })

    const rect1Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const rect2Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const rect3Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const rect4Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });

    rect1Anim
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 1,
        xPercent: 3,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 4,
        xPercent: 2,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })

    rect2Anim
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 1,
        xPercent: 5,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 1,
        xPercent: 5,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 4,
        xPercent: 1,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 4,
        xPercent: 1,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 2,
        xPercent: 4,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 2,
        xPercent: 4,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      }, "<")

    rect3Anim
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 1,
        xPercent: 1,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 3,
        xPercent: -4,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 2,
        xPercent: -1,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 4,
        xPercent: 1,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })

    rect4Anim
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: -3,
        xPercent: 4,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: -5,
        xPercent: 1,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: -1,
        xPercent: 3,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })
  })

  mm.add("(max-width: 992px)", () => {

    const introAnimation = gsap.timeline({
      defaults: {
        duration: introDuration,
        ease: "power1.inOut"
      },

      // onComplete: () => {

      //   gsap.set('.home__content', {
      //     opacity: 1,
      //   })

      //   gsap.set(homeTitleSelector, {
      //     opacity: 1,
      //   })

      //   gsap.set(scrollSelector, {
      //     opacity: 1,
      //   })

      //   const mainAnimation = gsap.timeline({
      //     defaults: {
      //       duration: 50,
      //       ease: "power1.inOut"
      //     },

      //     scrollTrigger: {
      //       trigger: root,
      //       pin: true,
      //       start: "top top",
      //       end: "+=2000",
      //       scrub: true,
      //     },
      //   })

      //   mainAnimation
      //     .to(homeLogoLeftSelector, {
      //       width: '20%',
      //       top: 10,
      //       transform: "translateY(0)"
      //     })
      //     .to(homeLogoRightSelector, {
      //       width: '50%',
      //       top: 10,
      //       transform: "translateY(0)"
      //     }, "<")
      //     .from(homeTitleSelector, {
      //       opacity: 0,
      //     })
      //     .from(contentItemRightSelector, {
      //       x: '200%',
      //       opacity: 0,
      //     })
      //     .from(contentItemleftSelector, {
      //       x: '-200%',
      //       opacity: 0,
      //     }, "<")
      //     .to(scrollSelector, {
      //       opacity: 0,
      //     })
      //     .from(contentBottomSelector, {
      //       opacity: 0,
      //     })
      // }
    });

    introAnimation
      .from(sunSection, {
        duration: introDuration,
        x: '-150%',
        y: '100%',
        // ease: "elastic.out(.2, .5)",
        ease: "back.out(1.5)"
      })
      .from(sunLine1Section, {
        duration: introDuration,
        xPercent: 40,
        yPercent: 600,
        opacity: 0,
      })
      .from(sunLine2Section, {
        duration: introDuration,
        xPercent: 200,
        yPercent: -10,
        opacity: 0,
      })
      .from(sunLine3Section, {
        duration: introDuration,
        xPercent: 40,
        yPercent: -550,
        opacity: 0,
      })
      .from(sunDate1Section, {
        duration: introDuration,
        opacity: 0,
      })
      .from(sunDate2Section, {
        duration: introDuration,
        opacity: 0,
      })
      .from(sunDate3Section, {
        duration: introDuration,
        opacity: 0,
      })
      .from(sunMonthSection, {
        duration: introDuration,
        opacity: 0,
      })
      .to(sunSection, {
        duration: introDuration,
        width: '50%',
        // ease: "elastic.out(.2, .5)",
      })
      .from(logoRectBlueSection, {
        opacity: 0,
        rotate: 10,
        transformOrigin: 'center',
        scale: .6
      })
      .from(logoRectBlueLineSection, {
        opacity: 0,
        rotate: 10,
        transformOrigin: 'center',
        scale: .6
      }, "<")
      .from(logoLine1Section, {
        opacity: 0,
        rotate: -10,
        transformOrigin: 'center',
        scale: .6
      })
      .from(logoLine2Section, {
        opacity: 0,
        rotate: 10,
        transformOrigin: 'center',
        scale: .6
      })
      .from(logoRectSmallBlueSection, {
        opacity: 0,
      }, "<")
      .from(logoRectSmallyellowSection, {
        opacity: 0,
      }, "<")
      .from(logoRectRed1Section, {
        rotate: 10,
        transformOrigin: 'center',
        opacity: 0,
        scale: .6
      })
      .from(logoRectRed2Section, {
        rotate: 10,
        transformOrigin: 'center',
        opacity: 0,
        scale: .6
      }, "<")
      .from(logoRectRedLineSection, {
        rotate: 10,
        transformOrigin: 'center',
        opacity: 0,
        scale: .6
      }, "<")
      // .set('.home__content', {
      //   opacity: 1,
      // })

      // .set(homeTitleSelector, {
      //   opacity: 1,
      // })

      // .set(scrollSelector, {
      //   opacity: 1,
      // })
      .to(homeLogoLeftSelector, {
        width: '20%',
        top: 10,
        transform: "translateY(0)"
      })
      .to(homeLogoRightSelector, {
        width: '50%',
        top: 10,
        transform: "translateY(0)"
      }, "<")
      .to(homeTitleSelector, {
        opacity: 1,
      })
      .set('.home__content', {
        opacity: 1,
      })
      .from(contentItemRightSelector, {
        x: '200%',
        opacity: 0,
      })
      .from(contentItemleftSelector, {
        x: '-200%',
        opacity: 0,
      }, "<")
      .to(scrollSelector, {
        opacity: 0,
      })
      .from(contentBottomSelector, {
        opacity: 0,
      })


    const line1Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const line2Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const line3Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const circleAnim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });

    line1Anim
      .to(sunLine1Section, {
        // duration: .8,
        y: -5,
        x: -5,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 0,
        x: -5,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 5,
        x: 0,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 5,
        x: 5,
      })
      .to(sunLine1Section, {
        // duration: .8,
        y: 0,
        x: 0,
      });

    line2Anim
      .to(sunLine2Section, {
        // duration: .8,
        y: 5,
        x: 5,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: 0,
        x: 0,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: -5,
        x: 0,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: -5,
        x: 5,
      })
      .to(sunLine2Section, {
        // duration: .8,
        y: 0,
        x: 0,
      })

    line3Anim
      .to(sunLine3Section, {
        // duration: .8,
        y: 0,
        x: 5,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: -5,
        x: 0,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: 0,
        x: -5,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: 5,
        x: 0,
      })
      .to(sunLine3Section, {
        // duration: .8,
        y: 0,
        x: 0,
      })

    circleAnim
      .to(sunCircleSection, {
        // duration: .8,
        y: 3,
        x: 0,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: -3,
        x: 0,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: 0,
        x: -3,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: 3,
        x: 0,
      })
      .to(sunCircleSection, {
        // duration: .8,
        y: 0,
        x: 0,
      })

    const rect1Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const rect2Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const rect3Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
    const rect4Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });

    rect1Anim
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 1,
        xPercent: 3,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 4,
        xPercent: 2,
      })
      .to(logoRectBlueSection, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })

    rect2Anim
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 3,
        xPercent: 1,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 1,
        xPercent: 5,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 1,
        xPercent: 5,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 4,
        xPercent: 1,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 4,
        xPercent: 1,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 2,
        xPercent: 4,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 2,
        xPercent: 4,
      }, "<")
      .to(logoRectSmallBlueSection, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })
      .to(logoRectSmallyellowSection, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      }, "<")

    rect3Anim
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 1,
        xPercent: 1,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 3,
        xPercent: -4,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 2,
        xPercent: -1,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 4,
        xPercent: 1,
      })
      .to(logoRectRed1Section, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })

    rect4Anim
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: -3,
        xPercent: 4,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: -5,
        xPercent: 1,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: -1,
        xPercent: 3,
      })
      .to(logoRectRed2Section, {
        // duration: .8,
        yPercent: 0,
        xPercent: 0,
      })
  })

  // const introAnimation = gsap.timeline({
  //   defaults: {
  //     duration: introDuration,
  //     ease: "power1.inOut"
  //   },

  //   onComplete: () => {
  //     scrollAnimation();
  //   }
  // });

  // introAnimation
  //   .from(sunSection, {
  //     duration: introDuration,
  //     x: '-150%',
  //     y: '101%',
  //     // ease: "elastic.out(.2, .5)",
  //   })
  //   .to(sunSection, {
  //     duration: introDuration,
  //     y: 20,
  //     ease: "back.out(5)"
  //   })
  //   .from(sunLine1Section, {
  //     duration: introDuration,
  //     xPercent: 40,
  //     yPercent: 600,
  //     opacity: 0,
  //   })
  //   .from(sunLine2Section, {
  //     duration: introDuration,
  //     xPercent: 200,
  //     yPercent: -10,
  //     opacity: 0,
  //   })
  //   .from(sunLine3Section, {
  //     duration: introDuration,
  //     xPercent: 40,
  //     yPercent: -550,
  //     opacity: 0,
  //   })
  //   .from(sunDate1Section, {
  //     duration: introDuration,
  //     opacity: 0,
  //   })
  //   .from(sunDate2Section, {
  //     duration: introDuration,
  //     opacity: 0,
  //   })
  //   .from(sunDate3Section, {
  //     duration: introDuration,
  //     opacity: 0,
  //   })
  //   .from(sunMonthSection, {
  //     duration: introDuration,
  //     opacity: 0,
  //   })
  //   .from(logoRectBlueSection, {
  //     opacity: 0,
  //     rotate: 10,
  //     transformOrigin: 'center',
  //     scale: .6
  //   })
  //   .from(logoRectBlueLineSection, {
  //     opacity: 0,
  //     rotate: 10,
  //     transformOrigin: 'center',
  //     scale: .6
  //   }, "<")
  //   .from(logoLine1Section, {
  //     opacity: 0,
  //     rotate: -10,
  //     transformOrigin: 'center',
  //     scale: .6
  //   })
  //   .from(logoLine2Section, {
  //     opacity: 0,
  //     rotate: 10,
  //     transformOrigin: 'center',
  //     scale: .6
  //   })
  //   .from(logoRectSmallBlueSection, {
  //     opacity: 0,
  //   }, "<")
  //   .from(logoRectSmallyellowSection, {
  //     opacity: 0,
  //   }, "<")
  //   .from(logoRectRed1Section, {
  //     rotate: 10,
  //     transformOrigin: 'center',
  //     opacity: 0,
  //     scale: .6
  //   })
  //   .from(logoRectRed2Section, {
  //     rotate: 10,
  //     transformOrigin: 'center',
  //     opacity: 0,
  //     scale: .6
  //   }, "<")
  //   .from(logoRectRedLineSection, {
  //     rotate: 10,
  //     transformOrigin: 'center',
  //     opacity: 0,
  //     scale: .6
  //   }, "<")


  // const line1Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
  // const line2Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
  // const line3Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
  // const circleAnim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });

  // line1Anim
  //   .to(sunLine1Section, {
  //     // duration: .8,
  //     y: -5,
  //     x: -5,
  //   })
  //   .to(sunLine1Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: -5,
  //   })
  //   .to(sunLine1Section, {
  //     // duration: .8,
  //     y: 5,
  //     x: 0,
  //   })
  //   .to(sunLine1Section, {
  //     // duration: .8,
  //     y: 5,
  //     x: 5,
  //   })
  //   .to(sunLine1Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: 0,
  //   });

  // line2Anim
  //   .to(sunLine2Section, {
  //     // duration: .8,
  //     y: 5,
  //     x: 5,
  //   })
  //   .to(sunLine2Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: 0,
  //   })
  //   .to(sunLine2Section, {
  //     // duration: .8,
  //     y: -5,
  //     x: 0,
  //   })
  //   .to(sunLine2Section, {
  //     // duration: .8,
  //     y: -5,
  //     x: 5,
  //   })
  //   .to(sunLine2Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: 0,
  //   })

  // line3Anim
  //   .to(sunLine3Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: 5,
  //   })
  //   .to(sunLine3Section, {
  //     // duration: .8,
  //     y: -5,
  //     x: 0,
  //   })
  //   .to(sunLine3Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: -5,
  //   })
  //   .to(sunLine3Section, {
  //     // duration: .8,
  //     y: 5,
  //     x: 0,
  //   })
  //   .to(sunLine3Section, {
  //     // duration: .8,
  //     y: 0,
  //     x: 0,
  //   })

  // circleAnim
  //   .to(sunCircleSection, {
  //     // duration: .8,
  //     y: 3,
  //     x: 0,
  //   })
  //   .to(sunCircleSection, {
  //     // duration: .8,
  //     y: -3,
  //     x: 0,
  //   })
  //   .to(sunCircleSection, {
  //     // duration: .8,
  //     y: 0,
  //     x: -3,
  //   })
  //   .to(sunCircleSection, {
  //     // duration: .8,
  //     y: 3,
  //     x: 0,
  //   })
  //   .to(sunCircleSection, {
  //     // duration: .8,
  //     y: 0,
  //     x: 0,
  //   })

  // const rect1Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
  // const rect2Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
  // const rect3Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });
  // const rect4Anim = gsap.timeline({ repeat: -1, defaults: { duration: .8, ease: "power1.inOut" } });

  // rect1Anim
  //   .to(logoRectBlueSection, {
  //     // duration: .8,
  //     yPercent: 3,
  //     xPercent: 1,
  //   })
  //   .to(logoRectBlueSection, {
  //     // duration: .8,
  //     yPercent: 1,
  //     xPercent: 3,
  //   })
  //   .to(logoRectBlueSection, {
  //     // duration: .8,
  //     yPercent: 3,
  //     xPercent: 1,
  //   })
  //   .to(logoRectBlueSection, {
  //     // duration: .8,
  //     yPercent: 4,
  //     xPercent: 2,
  //   })
  //   .to(logoRectBlueSection, {
  //     // duration: .8,
  //     yPercent: 0,
  //     xPercent: 0,
  //   })

  // rect2Anim
  //   .to(logoRectSmallBlueSection, {
  //     // duration: .8,
  //     yPercent: 3,
  //     xPercent: 1,
  //   })
  //   .to(logoRectSmallyellowSection, {
  //     // duration: .8,
  //     yPercent: 3,
  //     xPercent: 1,
  //   }, "<")
  //   .to(logoRectSmallBlueSection, {
  //     // duration: .8,
  //     yPercent: 1,
  //     xPercent: 5,
  //   })
  //   .to(logoRectSmallyellowSection, {
  //     // duration: .8,
  //     yPercent: 1,
  //     xPercent: 5,
  //   }, "<")
  //   .to(logoRectSmallBlueSection, {
  //     // duration: .8,
  //     yPercent: 4,
  //     xPercent: 1,
  //   })
  //   .to(logoRectSmallyellowSection, {
  //     // duration: .8,
  //     yPercent: 4,
  //     xPercent: 1,
  //   }, "<")
  //   .to(logoRectSmallBlueSection, {
  //     // duration: .8,
  //     yPercent: 2,
  //     xPercent: 4,
  //   })
  //   .to(logoRectSmallyellowSection, {
  //     // duration: .8,
  //     yPercent: 2,
  //     xPercent: 4,
  //   }, "<")
  //   .to(logoRectSmallBlueSection, {
  //     // duration: .8,
  //     yPercent: 0,
  //     xPercent: 0,
  //   })
  //   .to(logoRectSmallyellowSection, {
  //     // duration: .8,
  //     yPercent: 0,
  //     xPercent: 0,
  //   }, "<")

  // rect3Anim
  //   .to(logoRectRed1Section, {
  //     // duration: .8,
  //     yPercent: 1,
  //     xPercent: 1,
  //   })
  //   .to(logoRectRed1Section, {
  //     // duration: .8,
  //     yPercent: 3,
  //     xPercent: -4,
  //   })
  //   .to(logoRectRed1Section, {
  //     // duration: .8,
  //     yPercent: 2,
  //     xPercent: -1,
  //   })
  //   .to(logoRectRed1Section, {
  //     // duration: .8,
  //     yPercent: 4,
  //     xPercent: 1,
  //   })
  //   .to(logoRectRed1Section, {
  //     // duration: .8,
  //     yPercent: 0,
  //     xPercent: 0,
  //   })

  // rect4Anim
  //   .to(logoRectRed2Section, {
  //     // duration: .8,
  //     yPercent: 0,
  //     xPercent: 0,
  //   })
  //   .to(logoRectRed2Section, {
  //     // duration: .8,
  //     yPercent: -3,
  //     xPercent: 4,
  //   })
  //   .to(logoRectRed2Section, {
  //     // duration: .8,
  //     yPercent: -5,
  //     xPercent: 1,
  //   })
  //   .to(logoRectRed2Section, {
  //     // duration: .8,
  //     yPercent: -1,
  //     xPercent: 3,
  //   })
  //   .to(logoRectRed2Section, {
  //     // duration: .8,
  //     yPercent: 0,
  //     xPercent: 0,
  //   })

  return new Component({
    name: 'pageAnimations',
    requiredTargets: root,
    onCreate() { },
    onInit() { },
    onDestroy() { }
  })
}